window.clearSearch = function () {
    const elem = document.getElementById('input-search');
    elem.value = '';
};
